import React, { Component, PropTypes } from 'react'
import { DropdownButton, MenuItem } from 'react-bootstrap'
import DeactivateConfirmModal from './DeactivateConfirmModal'
import ReactivateConfirmModal from './ReactivateConfirmModal'

class ManageAction extends Component {

  constructor (props) {
    super(props)
    this.state = ({
      showDeactivateModal: false,
      showReactivateModal: false
    })
  }

  render () {
    let menuItem
    if (this.props.status === 'Active') {
      menuItem = (
        <DropdownButton bsStyle={'primary'} pullRight title={'Manage'}>
          <MenuItem eventKey='1' onClick={this._onClickEdit}>Edit</MenuItem>
          <MenuItem eventKey='2' onClick={this._onClickDeactivate}>Deactivate</MenuItem>
        </DropdownButton>
      )
    } else {
      menuItem = (
        <DropdownButton bsStyle={'primary'} pullRight title={'Manage'}>
          <MenuItem eventKey='1' onClick={this._onClickReactivate}><span style={{color: '#59bc23'}}>Reactivate</span></MenuItem>
          <MenuItem eventKey='2' onClick={this._onClickReset}>Reset Program</MenuItem>
        </DropdownButton>
      )
    }

    return (
      <div>
        {menuItem}
        <DeactivateConfirmModal
          show={this.state.showDeactivateModal}
          close={this._closeDeactivateModal}
          confirm={this._confirmDeactivate}
        />
        <ReactivateConfirmModal
          show={this.state.showReactivateModal}
          close={this._closeReactivateModal}
          confirm={this._confirmReactivate}
        />
      </div>
    )
  }

  _onClickEdit = (e) => {
    this.props.showEdit()
  }

  _onClickReset = (e) => {
    this.props.showReset()
  }

  _onClickDeactivate = (e) => {
    this.setState({
      showDeactivateModal: true
    })
  }

  _confirmDeactivate = () => {
    this._closeDeactivateModal()
    this.props.deactivateLoyalty()
  }

  _closeDeactivateModal = () => {
    this.setState({
      showDeactivateModal: false
    })
  }

  _onClickReactivate = (e) => {
    this.setState({
      showReactivateModal: true
    })
  }

  _confirmReactivate = (shouldResetPointBalance) => {
    this._closeReactivateModal()
    this.props.reactivateLoyalty(shouldResetPointBalance)
  }

  _closeReactivateModal = () => {
    this.setState({
      showReactivateModal: false
    })
  }
}

ManageAction.contextTypes = {
  mixpanel: PropTypes.object.isRequired
}

export default ManageAction



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Existing/ManageAction.js